import { useCallback } from 'react'
import { Consultant, ConsultantSearchQuery, ConsultantSearchResponse } from './types'
import { useRequest } from '../useRequest'
import { SALES_SERVICE_URL } from 'config'

enum ApiPathname {
  CONSULTANTS = '/sales/v1/consultants',
}

interface UseHookContext {
  searchConsultants: (query: ConsultantSearchQuery) => Promise<ConsultantSearchResponse>
}

const useConsultantService = (): UseHookContext => {
  const baseUrl = new URL(SALES_SERVICE_URL)

  const searchConsultantsRequest = useRequest<ConsultantSearchQuery, ConsultantSearchResponse>({
    baseUrl,
    filterQueryToSearchParams: ({ gid, salesforceId, ...rest }) => ({
      ...rest,
      gid,
      salesforceId,
    }),
    pathname: ApiPathname.CONSULTANTS,
    transformResponse: async (response: Response) => {
      const data = await response.json()

      return data
    },
  })

  const searchConsultants = useCallback(
    (query: ConsultantSearchQuery) => searchConsultantsRequest(query),
    [searchConsultantsRequest]
  )

  return { searchConsultants }
}

export { useConsultantService }
export type { Consultant, ConsultantSearchQuery }
